import React from "react";
import FormattedHTMLMessage from "../FormattedHTMLMessage";

import FlipCard from "../flipCard";
import TextImageArray from "../textImageArray";
import TextWithBackgroundImage from "../textWithBackgroundImage";
import Carousel from "../carousel";
import HotspotsCard from "../hotspotsCard";
import Assesment from "../assessment";
import CardSort from "../cardSort";
import VRCards from "../vrCards";
import Intro from "../intro";

const components = (type, data, setFooterVisibilityReq) => {
  switch (type) {
    case "title":
      return (
        <h1 style={{ padding: "15px 15px" }}>
          {data?.content}
          <FormattedHTMLMessage
            value={data.content}
            id={data?.content_id ? data?.content_id : data?.content}
          />
        </h1>
      );

    case "text":
      return (
        <p style={{ padding: "0 15px" }}>
          <FormattedHTMLMessage
            value={data.content}
            id={data?.content_id ? data?.content_id : data?.content}
          />
        </p>
      );
    case "image_text_regular":
      return (
        <TextImageArray
          header={data.header}
          headerId={data.header_id}
          title={data.title}
          titleId={data.title_id}
          content={data.content}
          contentId={data.content_id}
          image={data.image}
          setFooterVisibilityReq={setFooterVisibilityReq}
        />
      );
    case "intro":
      return (
        <Intro
          image={data?.image}
          setFooterVisibilityReq={setFooterVisibilityReq}
        />
      );
    case "flipcard":
      return (
        <FlipCard
          setFooterVisibilityReq={setFooterVisibilityReq}
          interactive={data.interactive}
          title={data.title}
          title_id={data.title_id}
          content={data.content}
          content_id={data.content_id}
          items_per_row={data.items_per_row}
          show_title_bar={data.show_title_bar}
          cards={data.cards}
        />
      );
    case "image_text_full":
      return (
        <TextWithBackgroundImage
          interactive={data?.interactive}
          title={data.title}
          title_id={data.title_id}
          description={data.content}
          description_id={data.content_id}
          src={data.image}
          setFooterVisibilityReq={setFooterVisibilityReq}
        />
      );
    case "assesment":
      return (
        <Assesment
          interactive={data.interactive}
          assessmentId={data.data.assesmentId}
        />
      );
    case "hotspots":
      return (
        <HotspotsCard
          interactive={data.interactive}
          config={{
            intro: {
              title: data.title,
              title_id: data.title_id,
              content: data.content,
              content_id: data.content_id,
              button_label: data.button_label,
              button_label_id: data.button_label_id,
            },
            end: {
              title: data.conclusion_title,
              title_id: data.conclusion_title_id,
              content: data.conclusion_content,
              content_id: data.conclusion_content_id,
            },

            hotspots: data.hotspots,
            background: data.background,
          }}
          setFooterVisibilityReq={setFooterVisibilityReq}
        />
      );
    case "carousel":
      return (
        <Carousel
          setFooterVisibilityReq={setFooterVisibilityReq}
          interactive={data.interactive}
          config={data.content}
        />
      );
    case "card_sort":
      return (
        <CardSort
          setFooterVisibilityReq={setFooterVisibilityReq}
          interactive={data.interactive}
          question={data}
        />
      );
    case "vr":
      return (
        <VRCards
          setFooterVisibilityReq={setFooterVisibilityReq}
          interactive={data.interactive}
          vrcardsdata={data}
          sendVrData={function () {}}
        />
      );
    default:
      return <h1>Not Found</h1>;
  }
};

export const getComponent = (type, data, setFooterVisibilityReq) => {
  return components(type, data, setFooterVisibilityReq);
};
